export default __webpack_public_path__ + "static/media/35M.bc92016f.jpeg";